<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_SUM_REQUEST'
        )
      }"
    >
      <vue-numeric
        :disabled="
          $parent.$parent.projectDisabled ||
            $parent.project.IS_BLOCK_SUM_ZAIM == 1
        "
        currency=""
        separator="space"
        v-model="sumRequest"
        type="text"
        class="i-main-style i-wid-13"
        @change="updateSummRequest"
      />
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText("PROJECTS", "LOGIC", "UF_SUM_REQUEST")
        }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "uf_sum_request",
  data() {
    return {
      sumRequest: 0
    };
  },
  watch: {
    sumRequest: function(val) {
      this.$parent.$parent.removeError("PROJECTS", "LOGIC", "UF_SUM_REQUEST");
      this.$parent.project.UF_SUM_REQUEST = val;
      this.$parent.$parent.updateAllSumPercent();
    }
  },
  created() {
    this.sumRequest = this.$parent.project.UF_SUM_REQUEST;
  },
  methods: {
    updateSummRequest: function() {
      if (this.$parent.project.UF_IS_PROJECT_REGIONAL_PROGRAMM == 1) {
        let tenProcent =
          this.$parent.project.UF_SUM_REQUEST > 0
            ? this.$parent.project.UF_SUM_REQUEST / 10
            : 0;
        let idFond = this.$parent.project.OTHER_SOURCE_FINANCE
          .UF_OTHER_SOURCE_CODE.fond;
        let idRegFond = this.$parent.project.OTHER_SOURCE_FINANCE
          .UF_OTHER_SOURCE_CODE.regfond;

        if (this.$parent.project.OTHER_SOURCE_FINANCE.items_v3.length > 0) {
          this.$parent.project.OTHER_SOURCE_FINANCE.items_v3.forEach(function(
            item
          ) {
            if (
              (item.UF_OTHER_SOURCE_ID == idRegFond ||
                item.UF_OTHER_SOURCE_ID == idFond) &&
              item.UF_SUM_ALL == 0 &&
              tenProcent > 0
            ) {
              if (item.UF_OTHER_SOURCE_ID == idRegFond) {
                item.UF_SUM_ALL = tenProcent;
              }
              if (item.UF_OTHER_SOURCE_ID == idFond) {
                item.UF_SUM_ALL =
                  this.$parent.project.UF_SUM_REQUEST - tenProcent;
              }
            }
          },
          this);
        }
      }
    }
  }
};
</script>

<style scoped></style>
